import { useEffect, useState } from "react";
import api from "../../lib/api";

function DocFile({ path }) {
  const [url, setUrl] = useState(null);
  const [isPdf, setIsPdf] = useState(false);
  useEffect(() => {
    let blob;
    api.get(`/files/${path}`, { responseType: "blob" }).then((r) => {
      blob = URL.createObjectURL(r.data);
      setUrl(blob);
      setIsPdf(r.data.type === "application/pdf" || path.endsWith(".pdf"));
    });
    return () => { if (blob) URL.revokeObjectURL(blob); };
  }, [path]);
  if (!url) return <div className="p-12 text-center text-slate-500">Loading…</div>;
  if (isPdf) return <iframe src={url} className="w-full h-[80vh] border-0" title="document" />;
  return <img src={url} alt="document" className="max-w-full max-h-[80vh] mx-auto" />;
}

export function DocPreviewModal({ doc, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose} data-testid="doc-preview-modal">
      <div className="bg-white max-w-4xl w-full max-h-[90vh] overflow-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-slate-200">
          <div className="font-medium">{doc.original_filename || doc.doc_type}</div>
          <button onClick={onClose} data-testid="doc-preview-close" className="text-slate-500 hover:text-slate-900">✕</button>
        </div>
        <DocFile path={doc.storage_path} />
      </div>
    </div>
  );
}
